import {
	ChangeDetectionStrategy,
	Component,
	inject,
	input,
	output,
	signal,
	effect,
} from '@angular/core';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { AuSearchInputComponent } from '../au-search-input/au-search-input.component';
import { ILabel } from '@app/pages/settings/interfaces/labels.interfaces';
import { LabelQuickSearchPipe } from '@app/pages/settings/labels/pipes/label-quick-search.pipe';
import { LabelBadgeComponent } from '@app/pages/settings/labels/label-item-row/label-badge/label-badge.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LabelsService } from '@app/shared/services/labels.service';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
	selector: 'labels-list',
	imports: [
		NgxTolgeeModule,
		AuSearchInputComponent,
		LabelQuickSearchPipe,
		LabelBadgeComponent,
		MatCheckboxModule,
	],
	templateUrl: './labels-list.component.html',
	styleUrl: './labels-list.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabelsListComponent {
	private readonly labelsService = inject(LabelsService);
	selectedLabels = input<ILabel[]>([]);
	isOpen = input<boolean>(false);
	labelsChanged = output<ILabel[]>();
	labels = this.labelsService.labels;

	labelsSelection = new SelectionModel<ILabel>(
		true,
		[],
		true,
		(a: { pk: string }, b: { pk: string }) => a.pk === b.pk
	);

	searchText = signal<string>('');

	constructor() {
		effect(() => {
			if (!this.isOpen()) {
				this.searchText.set('');
			}
			this.labelsSelection.clear();
			this.labelsSelection.select(...this.selectedLabels());
		});
	}

	toggleLabel(label: ILabel) {
		this.labelsSelection.toggle(label);
		this.labelsChanged.emit(this.labelsSelection.selected);
	}
}
